<div class="flex flex-col lg:flex-row text-left gap-4">
  <div class="flex w-full lg:w-1/4 font-bold text-2xl justify-start items-center">
      {{title}}
  </div>
  <div [formGroup]="parentGroup" class="flex w-full lg:w-3/4 flex-grow">
    <input 
    type="text"
    [attr.inputmode]="inputMode"
    pattern="{{pattern}}"
    formControlName="{{fieldName}}"
    class="bg-gray-100 uppercase text-xl md:text-2xl lg:text-4xl w-full appearance-none border-2 border-gray-600 tabular-nums text-center font-mono p-4 pl-1 pr-1 md:pl-4 md:pr-4 rounded-2xl {{largeSpacing ? 'tracking-widest' : 'tracking-normal'}}"
    autofocus
    spellcheck=false>
  </div>
</div>